/*
  YouTube click-to-play facade.
  Replaces every embedded YouTube player in page content with a poster image and a play
  button; the real player loads only when a visitor clicks. Saves about 1 MB per page that
  embeds a video. Theme-independent: include once from the layout with defer.
*/
(function () {
  var SELECTOR = 'iframe[src*="youtube.com/embed/"], iframe[src*="youtube-nocookie.com/embed/"]';

  var css =
    '.yt-facade{position:relative;width:100%;max-width:100%;aspect-ratio:16/9;background:#000;overflow:hidden;border-radius:8px}' +
    '.yt-facade__play{position:absolute;inset:0;width:100%;height:100%;padding:0;border:0;background:#000;cursor:pointer}' +
    '.yt-facade__poster{width:100%;height:100%;object-fit:cover;opacity:.92}' +
    '.yt-facade__icon{position:absolute;left:50%;top:50%;width:68px;height:48px;transform:translate(-50%,-50%);background:rgba(0,0,0,.72);border-radius:12px}' +
    '.yt-facade__icon::after{content:"";position:absolute;left:50%;top:50%;transform:translate(-40%,-50%);border-style:solid;border-width:10px 0 10px 18px;border-color:transparent transparent transparent #fff}' +
    '.yt-facade__play:hover .yt-facade__icon,.yt-facade__play:focus-visible .yt-facade__icon{background:#e00}' +
    '.yt-facade__play:focus-visible{outline:3px solid #004ea0;outline-offset:2px}' +
    '.yt-facade__iframe{position:absolute;inset:0;width:100%;height:100%;border:0}';

  function videoId(src) {
    var match = /embed\/([A-Za-z0-9_-]{6,})/.exec(src);
    return match ? match[1] : null;
  }

  function buildFacade(iframe) {
    var src = iframe.getAttribute('src');
    var id = videoId(src);
    if (!id) return;
    var title = iframe.getAttribute('title') || 'Video';

    var wrap = document.createElement('div');
    wrap.className = 'yt-facade';
    var w = parseInt(iframe.getAttribute('width'), 10);
    var h = parseInt(iframe.getAttribute('height'), 10);
    if (w > 0 && h > 0) wrap.style.aspectRatio = w + ' / ' + h;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'yt-facade__play';
    button.setAttribute('aria-label', 'Play video: ' + title);

    var poster = document.createElement('img');
    poster.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    poster.alt = '';
    poster.loading = 'lazy';
    poster.width = 480;
    poster.height = 360;
    poster.className = 'yt-facade__poster';
    button.appendChild(poster);

    var icon = document.createElement('span');
    icon.className = 'yt-facade__icon';
    icon.setAttribute('aria-hidden', 'true');
    button.appendChild(icon);

    button.addEventListener('click', function () {
      var player = document.createElement('iframe');
      var url;
      try {
        url = new URL(src, window.location.href);
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('rel', '0');
        player.src = url.toString();
      } catch (e) {
        player.src = src;
      }
      player.title = title;
      player.className = 'yt-facade__iframe';
      player.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      player.setAttribute('allowfullscreen', '');
      wrap.replaceChild(player, button);
    });

    wrap.appendChild(button);
    iframe.parentNode.replaceChild(wrap, iframe);
  }

  function init() {
    var frames = document.querySelectorAll(SELECTOR);
    if (!frames.length) return;
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
    Array.prototype.forEach.call(frames, buildFacade);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
